define('ssd_headerextension_header_logo.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('ssd_headerextension_header_logo', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true}, 'extensions/SSD/HeaderExtension/2.0.0/', 'extensions/SSD/HeaderExtension/2.0.0/', Handlebars);
});